import { map } from 'lodash';
import uuid from 'uuid/v1';
import { AUDIENCE_STATUS } from '../config';

export const combinedAudiencesTransformerToGW = ({ audienceSetup, name, ...rest }) => {
    const combinedSegmentComponents = map(audienceSetup, ({ audiences, relation }) => ({
        uddIds: audiences,
        relation: relation === 'EXCLUDE' ? 'NOT' : relation,
    }));

    return {
        ...rest,
        label: name,
        combinedSegmentComponents,
        isArchived: rest.status === undefined ? undefined : rest.status === AUDIENCE_STATUS.ARCHIVED,
    };
};

export const combinedAudiencesTransformerFromGW = ({ label, combinedSegmentComponents, ...rest }) => {
    const audienceSetup = map(combinedSegmentComponents, ({ uddIds, relation }) => ({
        id: uuid(),
        audiences: uddIds,
        relation: relation === 'NOT' ? 'EXCLUDE' : relation,
    }));
    return {
        ...rest,
        name: label,
        audienceSetup,
    };
};
